
    export const theme = {};
    export const setTheme = newTheme => Object.assign(theme, newTheme);
